module.exports = __webpack_public_path__ + "1f4f30bdb7d9676a7d93b10c61911f67.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_medium_x1/public/games/coh_image_1.jpg
// module id = 500
// module chunks = 0